import { render } from "./NotificacionesComp.vue?vue&type=template&id=e787b03c"
import script from "./NotificacionesComp.vue?vue&type=script&lang=js"
export * from "./NotificacionesComp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__